import { FC } from 'react'

import { colorVariant } from '@trustycars/genie-ui/style/atoms'
import { propsWithClassNames } from '@trustycars/genie-ui/functions'

import { Props } from './types'

const Partner: FC<Props> = ({ ...props }) => (
  <svg
    fill="none"
    width={125}
    height={32}
    viewBox="0 0 125 32"
    {...propsWithClassNames(props, colorVariant['text.default'])}
  >
    <g clipPath="url(#clip0_67_119)">
      <path
        d="M16 26C21.5228 26 26 21.5228 26 16C26 10.4772 21.5228 6 16 6C10.4772 6 6 10.4772 6 16C6 21.5228 10.4772 26 16 26Z"
        fill="white"
      />
      <mask
        height={32}
        id="mask0_67_119"
        maskUnits="userSpaceOnUse"
        style={{ maskType: 'alpha' }}
        width={32}
        x={0}
        y={0}
      >
        <path
          d="M23.4733 12.9986C23.4128 13.16 23.287 13.2909 23.1284 13.358L21.468 14.0604C21.1648 14.1885 20.8121 14.0613 20.6652 13.7712C19.7769 12.017 17.9317 10.9864 15.9654 11.1467C13.5374 11.3437 11.5958 13.4089 11.5453 15.8486C11.5183 17.1538 12.0074 18.3871 12.9223 19.3211C13.8377 20.2555 15.0601 20.7702 16.3642 20.7702C18.0493 20.7702 19.5832 19.9144 20.4676 18.481C20.6357 18.2081 20.9881 18.1111 21.2694 18.2599L22.8947 19.1189C23.0431 19.1972 23.1546 19.3351 23.2001 19.4969C23.2453 19.6579 23.2225 19.8322 23.1374 19.9753C21.725 22.3518 19.1295 23.8279 16.3642 23.8279C14.256 23.8279 12.2737 23.0027 10.7827 21.5043C9.2919 20.0062 8.4765 18.0197 8.48677 15.9111C8.50668 11.8236 11.7109 8.38968 15.7816 8.09398C19.0256 7.85697 22.0347 9.59026 23.4509 12.5063C23.5263 12.6616 23.5343 12.8364 23.4733 12.9986ZM29.1127 10.5693C28.3476 8.7243 28.7042 6.07669 27.3138 4.68624C25.9236 3.296 23.276 3.65247 21.431 2.88735C19.6512 2.14948 18.0466 0 16 0C13.9534 0 12.349 2.14948 10.5692 2.88735C8.72445 3.65247 6.07665 3.296 4.68642 4.68624C3.29598 6.07669 3.65265 8.7243 2.88775 10.5693C2.14968 12.3489 0 13.9535 0 16.0001C0 18.0467 2.14968 19.6513 2.88754 21.4309C3.65265 23.2759 3.29598 25.9235 4.68642 27.3138C6.07665 28.7042 8.72445 28.3477 10.5692 29.1126C12.349 29.8507 13.9534 32 16 32C18.0466 32 19.6512 29.8507 21.431 29.1126C23.276 28.3477 25.9234 28.7042 27.3138 27.314C28.704 25.9235 28.3476 23.2759 29.1127 21.4309C29.8505 19.6513 32 18.0467 32 16.0001C32 13.9535 29.8505 12.3489 29.1127 10.5693Z"
          fill="#FBFBFB"
          clipRule="evenodd"
          fillRule="evenodd"
        />
      </mask>
      <g mask="url(#mask0_67_119)">
        <mask
          height={32}
          id="mask1_67_119"
          maskUnits="userSpaceOnUse"
          style={{ maskType: 'alpha' }}
          width={32}
          x={0}
          y={0}
        >
          <path d="M32 0H0V32H32V0Z" fill="white" />
        </mask>
        <g mask="url(#mask1_67_119)">
          <path d="M31.9995 0H-0.000549316V32H31.9995V0Z" fill="white" />
          <g filter="url(#filter0_f_67_119)">
            <path
              d="M47.3516 20.7409C43.1275 11.7614 34.2254 7.05877 27.4683 10.2374C20.7113 13.416 18.6579 23.2722 22.882 32.2518C27.1062 41.2314 36.0082 45.934 42.7653 42.7553C49.5223 39.5767 51.5757 29.7205 47.3516 20.7409Z"
              fill="#CE5FEA"
            />
          </g>
          <g filter="url(#filter1_f_67_119)">
            <path
              d="M11.4716 18.2151C3.53458 12.2586 -5.74081 11.2158 -9.24556 15.8859C-12.7503 20.556 -9.15723 29.1705 -1.2202 35.127C6.71683 41.0834 15.9922 42.1263 19.497 37.4562C23.0017 32.7861 19.4086 24.1715 11.4716 18.2151Z"
              fill="#1E10BE"
            />
          </g>
          <g filter="url(#filter2_f_67_119)">
            <path
              d="M25.8749 11.9548C27.5994 6.78917 21.2176 0.00442791 11.6209 -3.19936C2.02409 -6.40315 -7.15359 -4.81278 -8.87808 0.352831C-10.6026 5.51844 -4.22084 12.3032 5.37592 15.507C14.9727 18.7108 24.1504 17.1204 25.8749 11.9548Z"
              fill="#7A23E9"
            />
          </g>
          <g filter="url(#filter3_f_67_119)">
            <path
              d="M50.7165 4.26068C49.8289 14.8139 40.5544 22.6495 30.0012 21.7619C19.448 20.8744 11.6124 11.5999 12.4999 1.04665C13.3874 -9.50656 22.662 -17.3421 33.2152 -16.4546C43.7684 -15.5671 51.604 -6.29253 50.7165 4.26068Z"
              fill="#5230FA"
            />
          </g>
          <g filter="url(#filter4_f_67_119)">
            <path
              d="M2.49947 18C-4.47762 14.0661 -8.34797 10.3305 -9.17181 9.34381C-8.39969 7.72094 7.15519 10.8214 10.4996 11.5006C23.2879 17.5849 19.7576 18.3556 18.9854 19.9785C18.2133 21.6014 9.83157 21.2738 2.49947 18Z"
              fill="#10A1F2"
            />
          </g>
        </g>
      </g>
    </g>
    <path
      d="M45.0615 10.4248C47.4988 10.4248 49.0306 11.1918 50.3477 13.0723C50.3954 13.1406 50.4136 13.2267 50.3975 13.3086C50.3813 13.3905 50.3311 13.4635 50.2607 13.5088L48.2949 14.7764C48.2246 14.8218 48.1408 14.837 48.0586 14.8193C47.9779 14.8019 47.9086 14.7543 47.8633 14.6855C47.1816 13.6506 46.2402 13.1475 44.9854 13.1475C43.9051 13.1475 42.9237 13.5942 42.2227 14.4062C41.5327 15.2056 41.1533 16.3 41.1533 17.4863C41.1534 19.6829 42.5645 21.2773 44.5088 21.2773C45.7326 21.2772 46.7291 20.832 47.4707 19.9541C47.5786 19.8265 47.7675 19.8053 47.9004 19.9062L49.7041 21.2754C49.7723 21.3274 49.8165 21.4055 49.8252 21.4902C49.8338 21.5749 49.8063 21.6606 49.75 21.7246C48.3852 23.2769 46.6893 24 44.4131 24C40.7571 24 38 21.1912 38 17.4668C38.0001 15.525 38.7484 13.7304 40.1074 12.4141C41.4322 11.131 43.1918 10.4248 45.0615 10.4248ZM95.3457 10.4248C97.1772 10.4248 98.8593 11.0807 100.082 12.2725C101.319 13.4778 102 15.1551 102 16.9951C102 19.0436 101.251 20.8122 99.834 22.1094C98.5024 23.3284 96.6943 23.9999 94.7432 24C92.9132 24 91.2343 23.3438 90.0166 22.1523C88.7864 20.9483 88.1085 19.2709 88.1084 17.4297C88.1084 15.38 88.8542 13.6116 90.2646 12.3154C91.5913 11.0963 93.3958 10.4248 95.3457 10.4248ZM106.666 14.876C107.236 14.876 107.744 14.9781 108.188 15.1826C108.631 15.3842 108.982 15.6606 109.241 16.0117C109.503 16.3631 109.642 16.7626 109.656 17.209H108.619C108.567 16.7712 108.357 16.4314 107.988 16.1895C107.62 15.9475 107.168 15.8262 106.632 15.8262C106.24 15.8262 105.897 15.8899 105.604 16.0166C105.313 16.1433 105.085 16.3173 104.921 16.5391C104.76 16.7607 104.679 17.0128 104.679 17.2949C104.679 17.5311 104.735 17.7344 104.848 17.9043C104.963 18.0713 105.11 18.2109 105.288 18.3232C105.467 18.4326 105.654 18.5237 105.85 18.5957C106.045 18.6648 106.226 18.7205 106.39 18.7637L107.288 19.0059C107.518 19.0663 107.775 19.1503 108.058 19.2568C108.343 19.3634 108.615 19.5082 108.874 19.6924C109.136 19.8738 109.352 20.1076 109.521 20.3926C109.691 20.6777 109.776 21.0277 109.776 21.4424C109.776 21.9203 109.652 22.3524 109.401 22.7383C109.154 23.1241 108.79 23.4307 108.312 23.6582C107.837 23.8857 107.26 24 106.58 24C105.946 24 105.397 23.8978 104.934 23.6934C104.473 23.4889 104.111 23.2035 103.846 22.8379C103.584 22.4721 103.435 22.0473 103.4 21.5635H104.506C104.535 21.8976 104.648 22.1737 104.844 22.3926C105.042 22.6085 105.292 22.7704 105.595 22.877C105.9 22.9806 106.229 23.0322 106.58 23.0322C106.989 23.0322 107.356 22.9664 107.682 22.834C108.007 22.6986 108.265 22.5105 108.455 22.2715C108.645 22.0296 108.74 21.7472 108.74 21.4248C108.74 21.1313 108.658 20.8922 108.494 20.708C108.33 20.5237 108.114 20.374 107.846 20.2588C107.578 20.1436 107.289 20.0425 106.978 19.9561L105.889 19.6455C105.197 19.4468 104.65 19.1626 104.247 18.7939C103.844 18.4253 103.643 17.9428 103.643 17.3467C103.643 16.8515 103.776 16.4193 104.044 16.0508C104.315 15.6793 104.678 15.392 105.133 15.1875C105.591 14.9802 106.102 14.876 106.666 14.876ZM113.41 14.876C113.98 14.876 114.487 14.9782 114.931 15.1826C115.374 15.3842 115.726 15.6604 115.985 16.0117C116.247 16.3631 116.385 16.7626 116.399 17.209H115.363C115.311 16.7713 115.101 16.4314 114.732 16.1895C114.364 15.9476 113.912 15.8262 113.376 15.8262C112.984 15.8262 112.641 15.8899 112.348 16.0166C112.057 16.1433 111.829 16.3173 111.665 16.5391C111.504 16.7607 111.423 17.0128 111.423 17.2949C111.423 17.5311 111.479 17.7344 111.592 17.9043C111.707 18.0713 111.854 18.2109 112.032 18.3232C112.211 18.4327 112.398 18.5237 112.594 18.5957C112.79 18.6648 112.97 18.7205 113.134 18.7637L114.032 19.0059C114.263 19.0663 114.52 19.1503 114.802 19.2568C115.087 19.3634 115.359 19.5082 115.618 19.6924C115.88 19.8738 116.096 20.1076 116.266 20.3926C116.436 20.6777 116.52 21.0277 116.521 21.4424C116.521 21.9205 116.395 22.3524 116.145 22.7383C115.897 23.1241 115.534 23.4307 115.057 23.6582C114.581 23.8857 114.004 24 113.324 24C112.691 24 112.141 23.8978 111.678 23.6934C111.217 23.4889 110.854 23.2036 110.589 22.8379C110.327 22.4722 110.179 22.0472 110.145 21.5635H111.25C111.279 21.8974 111.391 22.1738 111.587 22.3926C111.786 22.6086 112.036 22.7704 112.339 22.877C112.644 22.9806 112.973 23.0322 113.324 23.0322C113.733 23.0322 114.1 22.9664 114.426 22.834C114.751 22.6986 115.009 22.5105 115.199 22.2715C115.389 22.0297 115.484 21.7472 115.484 21.4248C115.484 21.1312 115.401 20.8922 115.237 20.708C115.073 20.5238 114.858 20.3739 114.59 20.2588C114.322 20.1436 114.033 20.0424 113.722 19.9561L112.633 19.6455C111.942 19.4468 111.394 19.1626 110.991 18.7939C110.588 18.4253 110.387 17.9428 110.387 17.3467C110.387 16.8515 110.52 16.4193 110.788 16.0508C111.059 15.6793 111.422 15.392 111.877 15.1875C112.335 14.9802 112.846 14.876 113.41 14.876ZM120.828 14.876C121.583 14.876 122.254 15.0601 122.842 15.4287C123.429 15.7973 123.892 16.3215 124.229 17.001C124.565 17.6807 124.733 18.4878 124.733 19.4209C124.733 20.3539 124.565 21.1602 124.229 21.8398C123.892 22.5194 123.429 23.0435 122.842 23.4121C122.254 23.7808 121.583 23.9658 120.828 23.9658C120.074 23.9658 119.403 23.7807 118.815 23.4121C118.228 23.0435 117.766 22.5195 117.429 21.8398C117.092 21.1602 116.923 20.3539 116.923 19.4209C116.923 18.4878 117.092 17.6807 117.429 17.001C117.766 16.3215 118.228 15.7973 118.815 15.4287C119.403 15.0602 120.074 14.876 120.828 14.876ZM59.2168 9.45508C59.3357 9.45516 59.4396 9.53331 59.4668 9.64453L62.7979 23.2275C62.8199 23.3065 62.7971 23.3896 62.7354 23.4492C62.6891 23.4936 62.6239 23.5146 62.5586 23.5146H59.8848C59.7762 23.5145 59.6811 23.4439 59.6543 23.3428L59.2812 21.9238H53.8779L52.9619 23.4033C52.9191 23.4724 52.8416 23.5146 52.7578 23.5146H50.1445C50.059 23.5146 49.9795 23.47 49.9375 23.3984C49.8957 23.327 49.8974 23.2391 49.9414 23.1689L57.4336 9.58594C57.4781 9.50531 57.5652 9.45508 57.6602 9.45508H59.2168ZM69.4102 8C73.3731 8 75.7051 10.0305 75.7051 13.5215C75.705 15.7528 74.6871 17.875 72.3545 18.7998C72.2708 18.8332 72.2322 18.9315 72.2744 19.0117L74.5234 23.291C74.5768 23.3925 74.5036 23.5146 74.3896 23.5146H71.4717C71.4157 23.5146 71.3641 23.4835 71.3379 23.4336L69.3887 19.7246C69.3604 19.6709 69.3032 19.6402 69.2432 19.6445C69.0494 19.6586 68.8532 19.6592 68.6406 19.6592H67.1816C67.1086 19.6594 67.0462 19.7118 67.0332 19.7842L66.3984 23.3887C66.3856 23.4613 66.3224 23.5146 66.249 23.5146H63.4541C63.3601 23.5146 63.2884 23.4292 63.3047 23.3359L65.9688 8.12598C65.9815 8.05326 66.044 8.00023 66.1172 8H69.4102ZM81.5713 9.45508C83.4309 9.45515 84.9651 9.9122 86.0078 10.7773C87.0575 11.6485 87.6122 12.9334 87.6123 14.4932C87.6123 16.7814 86.4356 18.5365 84.3838 19.3076C84.3778 19.3099 84.375 19.314 84.374 19.3164C84.3726 19.3202 84.3739 19.3231 84.375 19.3252L86.4873 23.1357C86.532 23.2164 86.5297 23.3115 86.4805 23.3896C86.4312 23.4678 86.3445 23.5145 86.249 23.5146H83.5068C83.4067 23.5146 83.3156 23.4623 83.2686 23.3779L81.4375 20.0742C81.4341 20.0682 81.4264 20.0683 81.4238 20.0684C81.237 20.0814 81.0476 20.0811 80.8477 20.0811H79.4775C79.471 20.0812 79.4652 20.0858 79.4639 20.0918L78.8672 23.3018C78.8443 23.4253 78.7328 23.5146 78.6016 23.5146H75.9756C75.8956 23.5146 75.82 23.4814 75.7686 23.4229C75.7172 23.3643 75.6962 23.2874 75.71 23.2119L78.2119 9.66797C78.2349 9.5444 78.3473 9.45508 78.4785 9.45508H81.5713ZM120.828 15.8779C120.293 15.878 119.807 16.0135 119.372 16.2842C118.94 16.5549 118.596 16.9545 118.34 17.4814C118.087 18.0084 117.96 18.655 117.96 19.4209C117.96 20.1868 118.086 20.8334 118.34 21.3604C118.596 21.8872 118.94 22.2859 119.372 22.5566C119.807 22.8273 120.293 22.9628 120.828 22.9629C121.364 22.9629 121.848 22.8274 122.28 22.5566C122.715 22.2859 123.059 21.8872 123.312 21.3604C123.569 20.8334 123.697 20.1869 123.697 19.4209C123.697 18.655 123.569 18.0084 123.312 17.4814C123.059 16.9545 122.715 16.5549 122.28 16.2842C121.848 16.0135 121.364 15.8779 120.828 15.8779ZM95.2686 13.1514C92.8498 13.1514 91.2863 14.8525 91.2861 17.4863C91.2861 19.7521 92.7145 21.2752 94.8398 21.2754C97.2585 21.2754 98.8213 19.5733 98.8213 16.9395C98.8213 14.6735 97.3938 13.1515 95.2686 13.1514ZM55.3906 19.4854H58.6299L57.8125 14.4062L55.3906 19.4854ZM80.9111 12.1279L79.9395 17.4238C79.9387 17.4278 79.9398 17.4315 79.9424 17.4346C79.9452 17.4378 79.9489 17.4394 79.9531 17.4395H80.8906C83.1907 17.4393 84.3573 16.4484 84.3574 14.4941C84.3574 12.8728 83.3772 12.1173 81.2734 12.1172H80.9248C80.9182 12.1172 80.9124 12.1218 80.9111 12.1279ZM68.7217 10.7139C68.6484 10.7141 68.5858 10.7681 68.5732 10.8408L67.5391 16.7871C67.5228 16.8803 67.5946 16.9658 67.6885 16.9658H68.6855C71.1086 16.9658 72.5127 15.8935 72.5127 13.5205C72.5126 11.4901 71.2672 10.714 69.0938 10.7139H68.7217Z"
      fill="currentColor"
    />
    <defs>
      <filter
        colorInterpolationFilters="sRGB"
        filterUnits="userSpaceOnUse"
        height="74.5046"
        id="filter0_f_67_119"
        width="68.8613"
        x="0.686157"
        y="-10.7559"
      >
        <feFlood floodOpacity={0} result="BackgroundImageFix" />
        <feBlend
          in="SourceGraphic"
          in2="BackgroundImageFix"
          mode="normal"
          result="shape"
        />
        <feGaussianBlur
          result="effect1_foregroundBlur_67_119"
          stdDeviation={10}
        />
      </filter>
      <filter
        colorInterpolationFilters="sRGB"
        filterUnits="userSpaceOnUse"
        height="67.4109"
        id="filter1_f_67_119"
        width="71.4279"
        x="-30.5882"
        y="-7.03442"
      >
        <feFlood floodOpacity={0} result="BackgroundImageFix" />
        <feBlend
          in="SourceGraphic"
          in2="BackgroundImageFix"
          mode="normal"
          result="shape"
        />
        <feGaussianBlur
          result="effect1_foregroundBlur_67_119"
          stdDeviation={10}
        />
      </filter>
      <filter
        colorInterpolationFilters="sRGB"
        filterUnits="userSpaceOnUse"
        height="62.0151"
        id="filter2_f_67_119"
        width="75.3156"
        x="-29.1594"
        y="-24.8538"
      >
        <feFlood floodOpacity={0} result="BackgroundImageFix" />
        <feBlend
          in="SourceGraphic"
          in2="BackgroundImageFix"
          mode="normal"
          result="shape"
        />
        <feGaussianBlur
          result="effect1_foregroundBlur_67_119"
          stdDeviation={10}
        />
      </filter>
      <filter
        colorInterpolationFilters="sRGB"
        filterUnits="userSpaceOnUse"
        height="78.3536"
        id="filter3_f_67_119"
        width="78.3537"
        x="-7.5686"
        y="-36.5231"
      >
        <feFlood floodOpacity={0} result="BackgroundImageFix" />
        <feBlend
          in="SourceGraphic"
          in2="BackgroundImageFix"
          mode="normal"
          result="shape"
        />
        <feGaussianBlur
          result="effect1_foregroundBlur_67_119"
          stdDeviation={10}
        />
      </filter>
      <filter
        colorInterpolationFilters="sRGB"
        filterUnits="userSpaceOnUse"
        height="52.0493"
        id="filter4_f_67_119"
        width="69.1876"
        x="-29.1718"
        y="-11.1204"
      >
        <feFlood floodOpacity={0} result="BackgroundImageFix" />
        <feBlend
          in="SourceGraphic"
          in2="BackgroundImageFix"
          mode="normal"
          result="shape"
        />
        <feGaussianBlur
          result="effect1_foregroundBlur_67_119"
          stdDeviation={10}
        />
      </filter>
      <clipPath id="clip0_67_119">
        <rect fill="white" height={32} width={32} />
      </clipPath>
    </defs>
  </svg>
)

export default Partner
